import {
  APP_ENVIRONMENT,
  UNLEASH_CLIENT_KEY,
  UNLEASH_EDGE_CLIENT_KEY,
  UNLEASH_URL,
} from "../config/constants";
import { formatUnleashRegionUrl } from "../utils/utils";
class Unleash {
  config;

  constructor() {
    const unleashClientKey =
      APP_ENVIRONMENT === "development"
        ? UNLEASH_CLIENT_KEY
        : UNLEASH_EDGE_CLIENT_KEY;
    this.config = {
      appName: "advapacs-clinician",
      refreshInterval: 60,
      url:
        UNLEASH_URL ||
        formatUnleashRegionUrl(
          localStorage.getItem("region") as string,
          "api",
          localStorage.getItem("logged") === "true"
        ) + "/featureFlags/api/frontend",
      clientKey: unleashClientKey || "",
      environment: APP_ENVIRONMENT,
      storage: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        save: (name: string, data: any) => {
          localStorage.setItem(name, data);
        },
        get: (name: string) => localStorage.getItem(name),
      },
    };
  }

  getConfig() {
    return this.config;
  }
}

export default new Unleash();
